import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { config } from 'services/config';

export const authAPI = createApi({
  reducerPath: 'authAPI',
  baseQuery: fetchBaseQuery({
    baseUrl: config.BASE_URL,
    prepareHeaders: (headers, { endpoint }) => {
      const accessToken = localStorage.getItem('access_token'); // Fixed key to match what we're storing
      if (accessToken && endpoint !== 'login') {
        headers.set('Authorization', `Bearer ${accessToken}`);
      }
      // headers.set('Access-Control-Allow-Origin', '*');
      return headers;
    },
  }),
  tagTypes: ['Auth'],
  endpoints: builder => ({
    validate: builder.query<any, string>({
      query: token => ({
        url: 'api/v1/auth/validate',
        headers: { Authorization: `Bearer ${token}` },
      }),
    }),
  }),
});

export const { useLazyValidateQuery } = authAPI;
